import React from 'react';
import './SizeChartModal.css';

const SizeChartModal = ({ show, sizeChart, onClose }) => {
    if (!show || !sizeChart) return null;

    const renderSizeChartTable = (sizeChart) => {
        if (!sizeChart || sizeChart.length === 0) return null;

        // Find the maximum number of rows
        const maxRows = Math.max(...sizeChart.map(col => col.rows?.length || 0));
        
        // Create headers from column names
        const headers = sizeChart.map(col => col.name);
        
        // Create table data by row index
        const tableData = [];
        for (let rowIndex = 0; rowIndex < maxRows; rowIndex++) {
            const rowData = sizeChart.map(col => {
                // Find all rows with this row_index for this column
                const rowsWithIndex = col.rows?.filter(r => r.row_index === rowIndex.toString()) || [];
                // Get the first row if available, otherwise empty string
                const row = rowsWithIndex.length > 0 ? rowsWithIndex[0] : null;
                return row ? row.name : '';
            });
            tableData.push(rowData);
        }

        return (
            <table className="size-chart-table">
                <thead>
                    <tr>
                        {headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <div className="size-chart-modal-overlay" onClick={onClose}>
            <div className="size-chart-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="size-chart-modal-header">
                    <h3>Size Chart</h3>
                    <button 
                        type="button" 
                        className="size-chart-modal-close-btn" 
                        onClick={onClose}
                        aria-label="Close modal"
                    >
                        ×
                    </button>
                </div>
                <div className="size-chart-modal-body">
                    {renderSizeChartTable(sizeChart)}
                </div>
            </div>
        </div>
    );
};

export default SizeChartModal;
